// SignLaw — the sign law of a party's box, in one sentence, written once.
//
// THE RULE IT ENFORCES (§6 "The sign law, once per page"): the one wording is
//   Black = they owe the desk · red = the desk holds theirs
// rendered ONCE per page where balances carry a sign, with the one negative
// token. The party page printed it twice in two dialects ("Red = we owe them"
// above, "Red = the desk holds what is theirs" below); the Parties list had
// colours and no law. A page with no signed balance does not render it.
//
// Usage:
//   <SignLaw />                  // under the balances block, once
//   <SignLaw className="pt-2" />

export function SignLaw({ className = '' }: { className?: string }) {
  return (
    <p className={`text-meta text-tg-hint ${className}`}>
      Black = they owe the desk · <span className="text-neg">red</span> = the desk holds theirs
    </p>
  );
}
